function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from "react";
import { floral, useTheme } from "@thebouqs/system";
import { getIconRgb } from "./url-icon.utils";
import { Color } from "./url-icon.utils/Color.cjs";
import { Solver } from "./url-icon.utils/Solver.cjs";
var ObjectTag = floral("object");
/**
 *  Get an icon from an svg url and use bouqs components to style it
 *
 * @example
 * <UrlIcon url="https://cdn.staging.bouqs.com/storefront-ui/bouqs-ui-icons/sort.svg" alt="Some Icon" />
 */

export function UrlIcon(props) {
  var {
    url,
    alt,
    color
  } = props,
      iconProps = _objectWithoutPropertiesLoose(props, ["url", "alt", "color"]);

  var theme = useTheme();
  var iconFilter = useMemo(() => {
    if (color) {
      var rgbColor = getIconRgb(theme, color);
      var colorClass = new Color(rgbColor.r, rgbColor.g, rgbColor.b);

      var _iconFilter = new Solver(colorClass).solve();

      return _iconFilter.filter;
    }
  }, [color, theme]);

  var conditionalProps = _extends({}, iconFilter ? {
    filter: iconFilter
  } : {});

  return /*#__PURE__*/React.createElement(floral.div, _extends({
    w: "1em",
    h: "1em"
  }, iconProps), /*#__PURE__*/React.createElement(ObjectTag, _extends({}, conditionalProps, {
    w: "100%",
    h: "100%",
    maxWidth: "100%",
    type: "image/svg+xml" // Allow to be clicked (useful for use inside button)
    ,
    pointerEvents: "none",
    data: url,
    "aria-label": alt
  }), alt));
}
//# sourceMappingURL=url-icon.js.map